(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["big-bear-partnerships"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const link = event.target.closest('[data-bb-interest]');
  if (!link) return;
  const select = document.getElementById('bb-type');
  if (!select) return;
  const option = Array.from(select.options).find(item => item.dataset.interest === link.dataset.bbInterest);
  if (option) select.value = option.value;
});
function bbTyping(root) {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  root.querySelectorAll('.bb-typed:not([data-ready])').forEach(function(el) {
    el.dataset.ready = 'true';
    const text = el.getAttribute('aria-label');
    const output = el.querySelector('span');
    output.textContent = '';
    const observer = new IntersectionObserver(function(entries) {
      if (!entries.some(function(entry) { return entry.isIntersecting; })) return;
      observer.disconnect();
      let i = 0;
      const timer = setInterval(function() {
        output.textContent = text.slice(0, ++i);
        if (i >= text.length) clearInterval(timer);
      }, 55);
    }, {threshold: 0.8});
    observer.observe(el);
  });
}
bbTyping(document);
document.addEventListener('shopify:section:load', function(event) { bbTyping(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
